// src/pages/Analytics.js
import React from 'react';
import Layout from '../components/Layout';
import Chart from 'react-apexcharts';
import ComingSoon from '../components/ComingSoon';

function Analytics() {
    // Line chart configuration
    const lineChartOptions = {
        chart: {
            id: 'traffic-by-application',
            toolbar: {
                show: false
            }
        },
        xaxis: {
            categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun']
        },
        stroke: {
            curve: 'smooth'
        },
        dataLabels: {
            enabled: false
        },
        colors: ['#FF4560', '#00E396', '#008FFB']
    };

    const lineChartSeries = [
        {
            name: 'Proxmox',
            data: [31, 40, 28, 51, 42, 109]
        },
        {
            name: 'Minecraft',
            data: [11, 32, 45, 32, 34, 52]
        },
        {
            name: 'Speedtest.org',
            data: [15, 11, 32, 18, 9, 24]
        }
    ];

    // Pie chart configuration
    const pieChartOptions = {
        chart: {
            id: 'incoming-ports',
            type: 'pie'
        },
        labels: ['25565', '443', '8080', '19132', '8006', '21'],
        responsive: [{
            breakpoint: 480,
            options: {
                chart: {
                    width: 200
                },
                legend: {
                    position: 'bottom'
                }
            }
        }]
    };

    const pieChartSeries = [21, 22, 10, 28, 12, 7];

    // Other charts configuration would go here...

    return (
        <Layout>
            <ComingSoon>
            <div className="p-8">
            <h1 className="text-4xl font-bold text-white mb-8">Analytics</h1>
                {/* ... */}
                
                {/* Row for Traffic by Application and Incoming Ports */}
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-4">
                    {/* Traffic by Application Card */}
                    <div className="lg:col-span-2 bg-dark-card rounded-lg p-6 mb-4">
                        <h2 className="text-lg text-white mb-4">Traffic by Application (3)</h2>
                        <Chart options={lineChartOptions} series={lineChartSeries} type="line" height="230" />
                    </div>
                    
                    {/* Incoming Ports Card */}
                    <div className="bg-dark-card rounded-lg p-6 mb-4">
                        <h2 className="text-lg text-white mb-4">Incoming Ports</h2>
                        <Chart options={pieChartOptions} series={pieChartSeries} type="pie" height="230" />
                    </div>
                </div>
                
                {/* Row for Traffic by Country and Outgoing Ports */}
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
                    {/* Traffic by Country Card */}
                    <div className="lg:col-span-2 bg-dark-card rounded-lg p-6 mb-4">
                        <h2 className="text-lg text-white mb-4">Traffic by Country</h2>
                        {/* You'll replace this with an actual map component */}
                        <Chart options={lineChartOptions} series={lineChartSeries} type="line" height="230" />
                    </div>
                    
                    {/* Incoming Ports Card */}
                    <div className="bg-dark-card rounded-lg p-6 mb-4">
                        <h2 className="text-lg text-white mb-4">Incoming Ports</h2>
                        <Chart options={pieChartOptions} series={pieChartSeries} type="pie" height="230" />
                    </div>
                </div>
            </div>
            </ComingSoon>
        </Layout>
    );
}

export default Analytics;